angular.module('impactx.dashboard').controller('AddDashboardElementCtrl', [
    '$scope',
    '$mdDialog',
    'TranslationService',
    AddDashboardElementCtrl]);

function AddDashboardElementCtrl($scope, $mdDialog, TranslationService) {
    $scope.abortLabel = TranslationService.get("abort");
    $scope.confirmLabel = TranslationService.get("accept");
    $scope.errorList = [];

    var selectedWidth = null;
    var selectedHeight = null;

    var self = this;

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.answer = function () {
        var addedElement = $scope.setAvailablePanel;
        addedElement.width = selectedWidth.value;
        addedElement.height = selectedHeight.value;
        addedElement.rowPosition = self.rowPosition;
        addedElement.columnPosition = self.columnPosition;
        $mdDialog.hide(addedElement);
    };

    var widthOptions = [];
    for (var i = 1; i < 8; i++) {
        widthOptions.push({value: i});
    }
    var heightOptions = [];
    for (var j = 1; j < 8; j++) {
        heightOptions.push({value: j});
    }

    this.getNumbersForWidthOption = function() {
        return widthOptions;
    };

    this.getNumbersForHeightOption = function() {
        return heightOptions;
    };

    this.selectWidth = function (selectedOption) {
        if (selectedOption.selected) {
            selectedOption.selected = false;
            selectedWidth = null;
        }
        else {
            for (var i = 0; i < widthOptions.length; i++) {
                widthOptions[i].selected = false;
            }
            selectedOption.selected = true;
            selectedWidth = selectedOption;
        }
        self.checkForErrors();
    };

    this.selectHeight = function (selectedOption) {
        if (selectedOption.selected) {
            selectedOption.selected = false;
            selectedHeight = null;
        }
        else {
            for (var i = 0; i < heightOptions.length; i++) {
                heightOptions[i].selected = false;
            }
            selectedOption.selected = true;
            selectedHeight = selectedOption;
        }
        self.checkForErrors();
    };

    this.clearHeightAndWidthSelection = function () {
        selectedHeight = null;
        selectedWidth = null;
        for (var i = 0; i < heightOptions.length; i++) {
            if (i + 1 === $scope.setAvailablePanel.minHeight) {
                heightOptions[i].selected = true;
                selectedHeight = heightOptions[i];
            }
            else {
                heightOptions[i].selected = false;
            }
        }
        for (var j = 0; j < widthOptions.length; j++) {
            if (j + 1 === $scope.setAvailablePanel.minWidth) {
                widthOptions[j].selected = true;
                selectedWidth = widthOptions[j];
            }
            else {
                widthOptions[j].selected = false;
            }
        }
        self.checkForErrors();
    };

    this.checkForErrors = function () {
        $scope.errorList.length = 0;
        if (!$scope.setAvailablePanel) {
            $scope.errorList.push(self.trns.chooseOnePanel);
        }
        else {
            if (!selectedWidth) {
                $scope.errorList.push(self.trns.chooseWidth);
            }
            if (!selectedHeight) {
                $scope.errorList.push(self.trns.chooseHeight);
            }
        }
    };

    self.checkForErrors();
}